<template>
    <div class="background-small">
        <section class="faq-container">
            <h1 class="faq-title">Frequently Asked Questions</h1>

            <div class="faq-list">
                <details class="faq-item" v-for="(item, index) in faqItems" :key="index">
                    <summary>
                        {{ item.question }}
                        <span class="icon"></span>
                    </summary>
                    <div class="answer">
                        <p>{{ item.answer }}</p>
                    </div>
                </details>
            </div>
        </section>
    </div>
</template>

<script setup>
const faqItems = [
    {
        question: "What is SteamAnalyzer?",
        answer: "SteamAnalyzer is a tool designed for Steam market users to track item prices, monitor investments, and optimize trading strategies with real-time data, price alerts, and powerful P2P tools."
    },
    {
        question: "Is there a free plan available?",
        answer: "Yes! Our Basic plan is completely free and includes essential features such as price alerts, watchlist slots, and price history access perfect for casual traders."
    },
    {
        question: "How do price target alerts work?",
        answer: "You set a target price for an item, and we notify you when the market hits that price so you never miss a trading opportunity."
    },
    {
        question: "What is the P2P Lister tool?",
        answer: "Our P2P Lister lets you list up to 100 items quickly across platforms, helping you automate and optimize your selling strategy."
    },
    {
        question: "What is the Watchlist feature?",
        answer: "The Watchlist lets you track specific items by adding them to your personal list. You'll get price updates and alerts so you can monitor items without searching for them every time."
    },
    {
        question: "How does Investment Tracking work?",
        answer: "Investment Tracking helps you monitor the performance of your market purchases. Simply add your purchase data, and SteamAnalyzer will show you profit/loss over time, price changes, and historical performance."
    },
    {
        question: "Do I get 2 months free with the annual plans?",
        answer: "Yes! When you subscribe to any annual plan, you pay for 10 months and get 2 extra months free saving you money long-term."
    }
];
</script>

<style scoped>
.faq-wrapper {
    min-height: 100vh;
    background: linear-gradient(135deg, #1a1c2a 0%, #2a2d3e 100%);
    padding: 2rem 0;
}

.faq-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.faq-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: 700;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.faq-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.faq-item {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.faq-item summary {
    padding: 1.5rem;
    cursor: pointer;
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    position: relative;
}

.faq-item summary::marker {
    display: none;
}

.faq-item summary .icon {
    position: relative;
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
}

.faq-item summary .icon::before,
.faq-item summary .icon::after {
    content: '';
    position: absolute;
    background-color: white;
    transition: transform 0.3s ease;
}

.faq-item summary .icon::before {
    width: 2px;
    height: 20px;
    left: 9px;
    top: 0;
}

.faq-item summary .icon::after {
    width: 20px;
    height: 2px;
    left: 0;
    top: 9px;
}

.faq-item[open] summary .icon::before {
    transform: rotate(90deg);
}

.faq-item .answer {
    padding: 0 1.5rem 1.5rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
}

.faq-item .answer p {
    margin: 0;
    font-size: 1rem;
}

@media (max-width: 768px) {
    .faq-container {
        padding: 1rem;
    }

    .faq-title {
        font-size: 2rem;
        margin-bottom: 2rem;
    }

    .faq-item summary {
        padding: 1.25rem;
        font-size: 1rem;
    }

    .faq-item .answer {
        padding: 0 1.25rem 1.25rem;
    }
}
</style>